export const VIDEO_PLAY_STATES = {
    PLAYING: 'PLAYING',
    PAUSED: 'PAUSED',
    STOPPED: 'STOPPED',
    ENDED: 'ENDED',
};
